import type { QueryClient } from "@tanstack/react-query"

export type Revocation = "none" | "pending" | "failed"

interface Entry {
  state: Revocation
  listeners: Set<() => void>
}

const entries = new WeakMap<QueryClient, Entry>()

const entryOf = (queryClient: QueryClient): Entry => {
  let entry = entries.get(queryClient)
  if (!entry) {
    entry = { state: "none", listeners: new Set() }
    entries.set(queryClient, entry)
  }
  return entry
}

export const revocationOf = (queryClient: QueryClient): Revocation => entryOf(queryClient).state

export const setRevocation = (queryClient: QueryClient, state: Revocation): void => {
  const entry = entryOf(queryClient)
  if (entry.state === state) return
  entry.state = state
  entry.listeners.forEach((listener) => listener())
}

export const subscribeRevocation = (queryClient: QueryClient, listener: () => void): (() => void) => {
  const { listeners } = entryOf(queryClient)
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
